import "./abouthero.css";
import { lazy, Suspense } from "react";

const Grid = lazy(() => import("animated-grid-lines"));

const AboutHeroSection = () => {

    return (
        <section className="about-hero-container">
            <Suspense fallback={<div>...</div>}>
                <Grid
                    colors={["#00FFFF"]}
                    speed={20}
                    squareSize={60}
                    maxLineLength={100}
                    lineWidth={0.5}
                    gridColor="rgba(255, 255, 255, 0.1)"
                    className="about-animated-gridview"
                />
            </Suspense>

            <div className="about-hero-wrapper">

                <div className="about-head-container">
                    <span className="about-head">Risk Isn’t One-Dimensional.</span>
                    <span className="about-head-2">Neither Are We.</span>
                    <p className="about-head-3">BeFiSc was never about reducing risk to a single problem. For us, it was about looking deeper, <br className="break-text" /> beyond shortcuts and simple scores because risk keeps changing shape.</p>

                </div>
            </div>

        </section>
    )
}

export default AboutHeroSection;